import React from "react";

// Exact v19 "Filters ▾" pill (pp-filtertoggle). Toggles the advanced filter form.
export function FilterButton({ open, onClick, count = 0 }) {
  return (
    <button className={`pp-filtertoggle ${open ? "pp-open" : ""}`} onClick={onClick} data-testid="pp-filters-toggle">
      <svg viewBox="0 0 16 16"><path d="M2 4h12M4 8h8M6 12h4" /></svg>
      Filters
      {count > 0 ? <span className="pp-cvn">{count}</span> : null}
      <span className="pp-cv">▾</span>
    </button>
  );
}
